import { Body, Box, Container, HStack } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import TabItemMobile from './TabItemMobile';

const renderBody = (tabName: string) => {
  switch (tabName) {
    case 'problem':
      return (
        <Body size={500}>
          For high ticket jobs, they needed a tool to help them build a
          reputation for design and inspire homeowner confidence.
        </Body>
      );
    case 'solution':
      return (
        <Body size={500}>
          With HOVER Renderings, Colorado Siding Repair increased their close
          rate from 25% to 50%. They now offer a photorealistic HOVER Rendering
          to every homeowner lead to help them see the possibilities of their
          home.
        </Body>
      );
    case 'products used':
      return (
        <Body mb={100} size={500}>
          HOVER Renderings <br />
          Capture
          <br />
          Measurements
        </Body>
      );
    default:
      return (
        <Body size={500}>
          For high ticket jobs, they needed a tool to help them build a
          reputation for design and inspire homeowner confidence.
        </Body>
      );
  }
};

const SlideMobile: React.FC = () => {
  const [currentSection, setCurrentSection] = useState<string>('problem');

  const onTabSelect = (title: string) => {
    setCurrentSection(title);
  };

  return (
    <Box
      d={{ base: 'block', desktop: 'none' }}
      w="100%"
      flexDir="column"
      alignItems="flex-start"
    >
      <Container px={0}>
        <StaticImage
          objectFit="contain"
          placeholder="blurred"
          alt="real time 3d"
          src="../../../assets/images/rendering_case_study_1_tablet.jpg"
          style={{ borderRadius: '8px 8px 0 0' }}
        />
        <Box
          p={400}
          w="100%"
          bg="brandNavy.500"
          mt={200}
          borderRadius="0 0 8px 8px"
          shadow="distance300"
          mb={700}
          flexDirection="column"
        >
          <Body size={300} color="neutral.0" isSemiBold>
            “Every customer is worthy of this design experience. We use it to
            grab the homeowner’s attention, get them excited, and provide ideas.
            We also use it to clearly define the scope of the project that we’ve
            agreed upon.”
          </Body>
          <Body color="neutral.0" as="p" mt={2} size={200}>
            Stephen Chismarich
            <br />
            Director of Sales and Business Development
          </Body>
        </Box>
        <HStack spacing="auto" mb={700}>
          <TabItemMobile
            onSelect={onTabSelect}
            title="problem"
            isActive={currentSection === 'problem'}
          />
          <TabItemMobile
            onSelect={onTabSelect}
            title="solution"
            isActive={currentSection === 'solution'}
          />
          <TabItemMobile
            onSelect={onTabSelect}
            title="products used"
            isActive={currentSection === 'products used'}
          />
        </HStack>
        {renderBody(currentSection)}
      </Container>
    </Box>
  );
};

export default SlideMobile;
